var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.space.undergroundResources !== undefined)?[_c('div',{staticClass:"underground-token-background"}),_vm._v(" "),_c('div',{class:_vm.resourceClass})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }